import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FORM_LINK } from 'src/app/constant/constant';
import { ZoomService } from 'src/app/services/zoom.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { Router } from '@angular/router';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { url_testimonials_source } from 'src/app/models/feedback';
import { TraceClassDecorator } from '@sentry/angular';
// declare var $ : any;
// declare function count(a): any;

@Component({
    selector: 'app-home-special',
    templateUrl: './home-special.component.html',
    styleUrls: [
        './home-special.component.css',
        './../../../../assets/css/custom-egd-1.css'
    ]
})
@TraceClassDecorator()
export class HomeSpecialComponent implements OnInit {
    @Input('is_doctor')
    is_doctor: boolean = false;
    display2: boolean = false;
    url_link: string = '';
    feedback_url: string = 'feedback/' + url_testimonials_source["covid"];
    count_consultation: number;
    weekdays: string[][] = [
        ['6:00AM', '10:30AM'],
        ['5:30PM', '8:30PM']
    ];
    weekends: string[][] = [
        ['6:00AM', '10:30AM'],
        ['5:30PM', '9:30PM']
    ];
    form_link: string = FORM_LINK;
    response_success = null;

    constructor(
        public zoomService: ZoomService,
        public jsonDataService: JsonDataService,
        private router: Router,
        private utilitiesService: UtilitiesService
    ) { }

    async ngOnInit(): Promise<void> {
        await this.getLinkandTimings();
        await this.getConsultationData();
    }

    async getLinkandTimings() {
        await this.zoomService
            .GetCovidMeetLink()
            .toPromise()
            .then((result) => {
                if (result.success) {
                    this.response_success = result.success;
                    //Patient Link
                    if (this.is_doctor != null && !this.is_doctor) {
                        this.url_link = result.data.link;
                        //weekdays is at 0
                        this.weekdays = result.data.timings[0];
                        //weekdays is at 1
                        this.weekends = result.data.timings[1];
                    }
                }
            });
    }

    openZoomLink() {
        window.open(this.url_link, '_blank');
    }

    open_form() {
        window.open(this.form_link, '_blank');
    }
    async getConsultationData() {
        await this.jsonDataService.getConsultationData().then((result) => {
            if (result.success) {
                this.count_consultation = result.data.consultation_count;
            }
        });
    }

    getBoolean(value: any): boolean {
        return Boolean(value);
    }

    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }
}
